<template>
    <section class="main" :style="{'background-color': block.color, 'padding-top': block.paddingTop + 'px', 'padding-bottom': block.paddingBottom + 'px'}">
        <v-container style="position: relative; max-width: 1200px; margin: 0 auto">
            <v-row >
                <v-col :cols="cols" v-for="item in block.items" :key="item.id" style="position: relative">
                    <LinksBlockLink v-if="item.type == 'link'" :link="item.link"></LinksBlockLink>
                    <text-item v-if="item.type == 'text'" :item="item"></text-item>
                    <reportblockview v-if="item.type == 'report'" :report="item"></reportblockview>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
    import LinksBlockLink from "../../components/PageViewer/Items/LinksItem";
    import TextItem from "../../components/PageViewer/Items/TextItem";
    import Reportblockview from "./reportblockview";

    export default {
        name: "ItemsBlock",
        props:["block"],
        components:{
            Reportblockview,
            LinksBlockLink,
            TextItem
        },
        data(){
            return{
            }
        },
        computed:{
            cols () {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return 12
                    case 'sm': return 12
                    case 'md':
                        switch(this.block.cols){
                            case 1: return 12
                            case 2: return 6
                            case 3: return 4
                            case 4: return 3
                        }
                        break
                    case 'lg':
                        switch(this.block.cols){
                            case 1: return 12
                            case 2: return 6
                            case 3: return 4
                            case 4: return 3
                        }
                        break
                    case 'xl':
                        switch(this.block.cols){
                            case 1: return 12
                            case 2: return 6
                            case 3: return 4
                            case 4: return 3
                        }
                        break
                }
                return false
            }
        },
        methods:{
        }
    }
</script>

<style scoped>

    .main{
        position: relative;
    }

    .item-add-btn{
        width: 100%;
        height: 100%;
        border: 5px dashed rgba(0,0,0,.54);
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        transition: 0.3s;
        cursor: pointer;
    }

    .main:hover .item-add-btn{
        opacity: 0.5;
    }

    .item-select-btn{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        cursor: pointer;
    }

    .hovered{
        opacity: 0;
        transition: 0.3s;
    }

    .main:hover .hovered{
        opacity: 1;
    }




</style>